import axios from 'axios';

import { getServerUrl } from '../constants';
import { getAuthTokenFromStorage } from '../utils';

const SUBROUTE = 'role';

/**
 * @description gets all roles
 * @returns {Promise<Object>} API response
 */
export const fetchAllRoles = async () => {
  if (!global.API_URL) {
    global.API_URL = getServerUrl();
  }

  const url = `${global.API_URL}/${SUBROUTE}`;

  try {
    const { data: { data } } = await axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * @description creates a role object in the database
 * @param {Object} fields object with data to send
 * @param {String} fields.title title of role
 * @param {String} fields.description description of what the position is
 * @returns {Object} api response
 */
export const createRole = async (fields) => {
  const url = `${global.API_URL}/${SUBROUTE}`;
  const token = getAuthTokenFromStorage();

  try {
    const { data: { data } } = await axios.post(url, fields, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
